import React, { useState, useMemo } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

import CheckBox from 'src/components/CheckBox'
import Tooltip  from 'src/components/Tooltip'

const useCanadianReceipt = ({ partnerItem, partner_items }) => {
  const available = useMemo(() =>
    partnerItem.beneficiary.canada_helps || (
      partnerItem.beneficiary.id == '_multiple' &&
      partner_items.some(pi => pi.beneficiary.canada_helps)
    )
  , [ partnerItem.external_id ])

  const [ checked, setChecked ] = useState(() =>
    available && (
      partner_items.length
      ? partner_items.every(pi => pi.beneficiary.canada_helps)
      : partnerItem.beneficiary.canada_helps
    )
  )

  const render = () =>
    available &&
    <CheckBox
      label="I would like a Canadian tax receipt"
      afterLabel={
        <Tooltip title="Your Canadian tax receipt will be emailed to you at the
          beginning of next month, when the donations are processed and disbursed.">
          <FontAwesomeIcon icon={faInfoCircle} />
        </Tooltip>
      }
      id="canadaReceipt"
      checked={checked}
      onChange={e => setChecked(e.target.checked)}
    />

  return { render, value: available && checked }
}

export default useCanadianReceipt
